<template>
  <v-navigation-drawer app class="custom-navbar" v-model="drawer" width="270">
    <v-list density="compact" v-model:opened="open">
      <v-list-group value="favourite">
          <template #activator>
              <v-list-item @click="toggleFavourite()">
                  <div class="menu-item">
                      <v-icon class="menu-icon">mdi-star</v-icon>
                      <span class="menu-text font-weight-bold">お気に入り</span>
                      <v-icon class="ml-auto">
                          {{ open?.includes("favourite") ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                  </div>
              </v-list-item>
          </template>
          <v-list-group>
            <template #activator>
                <v-list-item v-for="(fav) in favouriteStore.favourite_list" :to="fav.menu_url" link>
                  <div class="menu-item">
                      <span class="menu-text">{{ fav.menu_name }}</span>
                  </div>
                </v-list-item>
            </template>
        </v-list-group>
      </v-list-group>
      <NavbarMenuItem v-for="(menu) in menuList" :menu v-model="open" />
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from 'vue-router';
import { useFavouriteStore } from '@/stores/favourite';
import NavbarMenuItem from "./navbar-menuItem.vue";

const favouriteStore = useFavouriteStore();
const props = defineProps<{
    temporary?: boolean,
}>()

const route = useRoute();
const drawer = defineModel<boolean>();
const open: Ref<String[]> = ref([]);

const response1 = ref();
const menuList = ref();
const favouriteList = ref();

watch(route, async (to) => {
  localStorage.setItem('click_url_admin', '1');
});
watch(open, async (to) => {
  if (localStorage.getItem('click_url_admin') == '1' && open.value.toString() !== localStorage.getItem('opening_menu_admin')) // them cai nay de set lai menu khi thay doi url
  open.value = (localStorage.getItem('opening_menu_admin') || '').split(',').map(item => item.trim());
});

onMounted(async () => {
  response1.value = (await useApi.post<any>("get_menu_list", {}, {})).response_data;
  menuList.value = response1.value.menu_list
  favouriteList.value = response1.value.favorite_menu_list

  favouriteStore.setter(favouriteList.value)

  findOpenMenu(menuList.value);
  open.value = result.filter((e:any) => e);
  localStorage.setItem('opening_menu_admin', open.value.toString());
});

let result: any[] = [];
const findOpenMenu = (menuList: any) => {
  for (let menu of menuList) {
    if (menu.children_menu_list && menu.children_menu_list.find((e: any) => route.fullPath.includes(e.menu_url)) ) {
      result.push(menu.menu_name);
    }

    if (Array.isArray(menu.children_menu_list)) {
      result = result.concat(findOpenMenu(menu.children_menu_list));
    }
  }
}

const toggleFavourite = () => {
  if (open.value) {
    localStorage.setItem('click_url_admin', '0');
    if (open.value.includes('favourite')) {
        open.value = open.value.filter(item => item != "favourite")
        localStorage.setItem('opening_menu_admin', open.value.filter(item => item != "favourite").toString());
    } else {
        open.value?.push("favourite")
        localStorage.setItem('opening_menu_admin', open.value.toString());
    }
  }
}

</script>
<style scoped>
.custom-navbar {
  background-color: #f8f9fa;
}

.menu-item {
  display: flex;
  align-items: center;
}

.menu-icon {
  font-size: 18px;
  margin-right: 8px;
  color: #ff9300;
}

.menu-text {
  font-size: 15px;
}

.custom-sub-item {
  padding-left: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
::v-deep(.v-list-item:hover) {
  background-color: #D2F4EA !important;
}
::v-deep(.v-list-item__append) {
  display: none !important;
}
::v-deep(div.v-list-item--variant-text .v-list-item__overlay) {
  background: none !important;
  border-top: 1px solid black;
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
::v-deep(div.v-list-item--variant-text.v-list-item--active .v-list-item__overlay) {
  border-bottom: 1px solid black;
}
::v-deep(.v-list.v-theme--light .v-list-group:first-child div.v-list-item--variant-text .v-list-item__overlay) {
  border-top: none;
}
::v-deep(.v-list.v-theme--light .v-list-group:last-child div.v-list-item--variant-text .v-list-item__overlay) {
  border-bottom: 1px solid black;
}
::v-deep(a.v-list-item--variant-text.v-list-item--active .v-list-item__overlay) {
  background: #D2F4EA !important;
  opacity: 1;
}
::v-deep(a.v-list-item--variant-text.v-list-item--active .menu-text) {
  font-weight: 700 !important;
  z-index: 999;
}
::v-deep(.v-list.v-theme--light > a.v-list-item--variant-text .v-list-item__overlay) {
  background: none !important;
  border-top: 1px solid black;
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
  font-weight: 700 !important;
}
::v-deep(.v-list.v-theme--light > a.v-list-item--variant-text .menu-text) {
  font-weight: 700 !important;
}
</style>
